import { render, staticRenderFns } from "./illustration.vue?vue&type=template&id=b57565f2&scoped=true&"
import script from "./illustration.vue?vue&type=script&lang=js&"
export * from "./illustration.vue?vue&type=script&lang=js&"
import style0 from "./illustration.vue?vue&type=style&index=0&id=b57565f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57565f2",
  null
  
)

export default component.exports